import {
  getBookSalesInfoRoute,
  getBookSalesRoute,
  type AmazonSalesResponse,
  type BookSalesResponse,
  type GetBookSalesInfoRouteData,
  type GetBookSalesRouteData,
  type SalesInfoResponse,
} from "reedy-data/api";
import { BaseApi } from "./base";

type GetSalesParams = Omit<GetBookSalesRouteData["query"], "isbns"> & {
  isbns: string[];
};

export class BooksApi extends BaseApi {
  /**
   * Window-independent sales metadata over all history: the earliest sale date
   * per source, the markets the selected ISBNs have sold into (home market
   * first), and the data-freshness signal. The first ISBN drives the Amazon
   * date; every ISBN is aggregated for the market date and the market set. Used
   * to anchor the date picker, the partial-history banner, and the chart/summary
   * market order.
   */
  async getSalesInfo(params: {
    isbns: string[];
  }): Promise<SalesInfoResponse | undefined> {
    const query: GetBookSalesInfoRouteData["query"] = {
      isbns: params.isbns.join(","),
    };

    const response = await this.request(getBookSalesInfoRoute, { query });
    return response?.data ?? undefined;
  }

  async getSales(
    params: GetSalesParams & { type: "market" },
  ): Promise<BookSalesResponse | undefined>;
  async getSales(
    params: GetSalesParams & { type: "amazon" },
  ): Promise<AmazonSalesResponse | undefined>;
  async getSales(
    params: GetSalesParams & { type: "market" | "amazon" },
  ): Promise<BookSalesResponse | AmazonSalesResponse | undefined>;
  async getSales(
    params: GetSalesParams & { type: "market" | "amazon" },
  ): Promise<BookSalesResponse | AmazonSalesResponse | undefined> {
    const query: GetBookSalesRouteData["query"] = {
      start: params.start,
      end: params.end,
      granularity: params.granularity,
      type: params.type,
      isbns: params.isbns.join(","),
    };

    const response = await this.request(getBookSalesRoute, { query });
    return response?.data ?? undefined;
  }
}
